
import React from 'react';
import AppLayout from '@/components/layout/AppLayout';
import ApplicationComplete from '@/components/application/ApplicationComplete';

const ApplicationCompletePage = () => {
  return (
    <AppLayout>
      <div className="container mx-auto px-4 py-6">
        <ApplicationComplete />
      </div>
    </AppLayout>
  );
};

export default ApplicationCompletePage;
